import { Dialog, DialogContent, Typography, Box, IconButton, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { useTheme } from '@mui/material/styles';

interface DraftPopupProps {
  open: boolean;
  onClose: () => void;
}

const AutoPopup: React.FC<DraftPopupProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '16px',
          padding: '10px 24px',
          width: '350px',
          height: '254px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          position: 'absolute',
          top: isMobile ? '20%' : '50%',
          left: isMobile ? '42%' : '50%',
          transform: 'translate(-50%, -50%)',
          boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.1)',
        },
      }}>
      {/* Close Icon */}
      <Box display='flex' justifyContent='flex-start' alignItems='center' padding='8px'>
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 10, left: 10 }}>
          <Image priority src='/icons/close-black.svg' alt='Close' width={24} height={24} />
        </IconButton>
      </Box>

      {/* Content */}
      <DialogContent
        sx={{
          textAlign: 'center',
          padding: '8px 24px 24px',
          flex: 1,
          overflowY: 'visible',
        }}>
        <Typography
          variant='h6'
          fontFamily="'DM Sans', sans-serif"
          fontWeight={400}
          fontSize='24px'
          lineHeight='32px'
          letterSpacing='0%'
          textAlign='center'
          color='black'
          gutterBottom
          sx={{
            width: '260px',
            height: '64px',
            marginBottom: '14px',
            marginTop: '17px',
          }}>
          Right now, your Memvy is saved as a draft.
        </Typography>

        <Typography
          variant='body2'
          fontFamily="'DM Sans', sans-serif"
          fontWeight={400}
          fontSize='16px'
          lineHeight='140%'
          letterSpacing='0%'
          textAlign='center'
          color='#000'
          gutterBottom
          sx={{
            width: '260px',
            minHeight: '88px',
            overflowWrap: 'break-word',
            margin: '0 auto',
          }}>
          When you’re ready to publish, select this dropdown and choose to publish to everyone (public) or by invite
          only (private).
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default AutoPopup;
